import { useEffect, type ReactNode } from 'react';
import { observer } from 'mobx-react-lite';
import { useNavigate } from 'react-router';
import { useStore } from './StoreContext';
import { getTelegramWebApp } from '@/platform/telegram';
import { runtime } from '@/platform/runtime';

export const MiniAppBootstrap = observer(function MiniAppBootstrap({ children }: { children: ReactNode }) {
  const { auth } = useStore();
  const nav = useNavigate();

  useEffect(() => {
    if (!runtime.isMiniApp) return;
    const tg = getTelegramWebApp()!;
    tg.ready();
    tg.expand();

    const applyViewport = () => {
      document.documentElement.style.setProperty(
        '--tg-viewport-height',
        `${tg.viewportStableHeight}px`,
      );
    };
    applyViewport();
    tg.onEvent('viewportChanged', applyViewport);

    void (async () => {
      try {
        await auth.authenticateTelegramMiniApp(tg.initData);
        const params = new URLSearchParams(window.location.search);
        const start = params.get('tgWebAppStartParam');
        if (start && /^[A-Z0-9]{6}$/i.test(start)) {
          nav(`/r/${start.toUpperCase()}`, { replace: true });
        }
      } catch (e) {
        console.error('Mini App auth failed', e);
      }
    })();

    return () => {
      tg.offEvent('viewportChanged', applyViewport);
    };
  }, []);

  return <>{children}</>;
});
